import * as signalR from '@microsoft/signalr';
import apiClient from './api';

// Derive the backend origin from the axios apiClient baseURL (strip trailing /api)
const HUB_URL = (function(){
  try {
    const baseUrl = apiClient?.defaults?.baseURL || window.location.origin;
    // remove trailing '/api' if present
    const backendOrigin = baseUrl.replace(/\/api\/?$/, '');
    return backendOrigin + '/hubs/messages';
  } catch (err) {
    return window.location.origin + '/hubs/messages';
  }
})();

class SignalRService {
  constructor() {
    this.connection = null;
    this.handlers = {};
  }

  async start(token) {
    if (this.connection) return;
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(HUB_URL, { accessTokenFactory: () => token })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Warning)
      .build();

    this.connection.onreconnecting((err) => console.warn('SignalR reconnecting', err));
    this.connection.onreconnected((id) => console.log('SignalR reconnected', id));
    this.connection.onclose((err) => console.warn('SignalR closed', err));

    // built-in generic handler dispatcher
    this.connection.on('MemberAdded', (payload) => {
      (this.handlers['MemberAdded'] || []).forEach(h => h(payload));
    });

    this.connection.on('Typing', (payload) => {
      (this.handlers['Typing'] || []).forEach(h => h(payload));
    });

    await this.connection.start();
    console.log('SignalR connected');
  }

  stop() {
    if (!this.connection) return;
    this.connection.stop();
    this.connection = null;
  }

  on(eventName, handler) {
    if (!this.handlers[eventName]) this.handlers[eventName] = [];
    this.handlers[eventName].push(handler);
    return () => {
      this.handlers[eventName] = this.handlers[eventName].filter(h => h !== handler);
    };
  }

  // convenience: send typing notifications
  async sendTyping(conversationId, senderId) {
    if (!this.connection) return;
    try {
      await this.connection.invoke('Typing', { conversationId, senderId });
    } catch (err) {
      console.warn('sendTyping failed', err);
    }
  }
}

export const signalRService = new SignalRService();
export default signalRService;
